module.exports = __webpack_public_path__ + "img/MARTA 2040_RGB.b9dc6f3c.jpg";